export const ORGANISATION_ACTIVITIES = [
  'Structured Cabling Installation',
  'Network Infrastructure Installation',
  'Audio Visual (AV) Installation',
  'IT Support & Managed Services',
  'Systems Integration',
  'Data Centre Services',
  'Security Systems Installation',
  'Building Controls / Smart Buildings',
  'Electrical Contracting',
  'Other (please specify)'
]

export const EMPLOYEE_RANGES = ['1', '2-5', '6-10', '11-25', '26-50', '51-100', 'More than 100']

export const EQUIPMENT_USE = [
  'On our own network infrastructure',
  'On customer network installations',
  'For testing and certification',
  'For maintenance and troubleshooting',
  'For training purposes',
  'Other'
]

export const CHART_MEASUREMENTS = [
  { value: 'Meters', label: 'Meters' },
  { value: 'Feet', label: 'Feet' }
]

export const CHART_LINE_STYLES = [
  { value: 'Standard', label: 'Standard' },
  { value: 'Inverted', label: 'Inverted' }
]

export const WIREMAP_DISPLAY_PREFERENCES = [
  { value: 'Standard', label: 'Standard' },
  { value: '568A', label: '568-A' },
  { value: '568B', label: '568-B' },
  { value: 'TERA', label: 'TERA' }
]

const ORGANISATION_ACTIVITY_TRANSLATION_KEYS = {
  'Structured Cabling Installation': 'organisation_activity_structured_cabling',
  'Network Infrastructure Installation': 'organisation_activity_network_infrastructure',
  'Audio Visual (AV) Installation': 'organisation_activity_audio_visual',
  'IT Support & Managed Services': 'organisation_activity_it_support',
  'Systems Integration': 'organisation_activity_systems_integration',
  'Data Centre Services': 'organisation_activity_data_centre',
  'Security Systems Installation': 'organisation_activity_security_systems',
  'Building Controls / Smart Buildings': 'organisation_activity_building_controls',
  'Electrical Contracting': 'organisation_activity_electrical_contracting',
  'Other (please specify)': 'organisation_activity_other'
}

const EQUIPMENT_USE_TRANSLATION_KEYS = {
  'On our own network infrastructure': 'organisation_equipment_own_network',
  'On customer network installations': 'organisation_equipment_customer_installations',
  'For testing and certification': 'organisation_equipment_testing_certification',
  'For maintenance and troubleshooting': 'organisation_equipment_maintenance',
  'For training purposes': 'organisation_equipment_training',
  Other: 'organisation_equipment_other'
}

const EMPLOYEE_RANGE_TRANSLATION_KEYS = {
  '1': 'organisation_field_team_1',
  '2-5': 'organisation_field_team_2_5',
  '6-10': 'organisation_field_team_6_10',
  '11-25': 'organisation_field_team_11_25',
  '26-50': 'organisation_field_team_26_50',
  '51-100': 'organisation_field_team_51_100',
  'More than 100': 'organisation_field_team_more_than_100'
}

const translateValue = (translate, key, fallback) => {
  if (typeof translate !== 'function' || !key) return fallback

  const translated = translate(key)
  return typeof translated === 'string' && translated !== key ? translated : fallback
}

const toOptions = (values, translationKeys, translate) => values.map(value => ({
  value,
  label: translateValue(translate, translationKeys[value], value)
}))

export const getOrganisationActivityOptions = translate =>
  toOptions(ORGANISATION_ACTIVITIES, ORGANISATION_ACTIVITY_TRANSLATION_KEYS, translate)

export const getEquipmentUseOptions = translate =>
  toOptions(EQUIPMENT_USE, EQUIPMENT_USE_TRANSLATION_KEYS, translate)

export const getEmployeeRangeOptions = translate =>
  toOptions(EMPLOYEE_RANGES, EMPLOYEE_RANGE_TRANSLATION_KEYS, translate)

export const getOrganisationActivityLabel = (value, translate) =>
  translateValue(translate, ORGANISATION_ACTIVITY_TRANSLATION_KEYS[value], value)

export const getEquipmentUseLabel = (value, translate) =>
  translateValue(translate, EQUIPMENT_USE_TRANSLATION_KEYS[value], value)

export const getChartMeasurementOptions = translate => [
  { value: 'Meters', label: translateValue(translate, 'organisation_measurement_meters', 'Meters') },
  { value: 'Feet', label: translateValue(translate, 'organisation_measurement_feet', 'Feet') }
]

export const getChartLineStyleOptions = translate => [
  { value: 'Standard', label: translateValue(translate, 'organisation_chart_style_standard', 'Standard') },
  { value: 'Inverted', label: translateValue(translate, 'organisation_chart_style_inverted', 'Inverted') }
]

export const getWiremapDisplayPreferenceOptions = translate => [
  { value: 'Standard', label: translateValue(translate, 'organisation_wiremap_standard', 'Standard') },
  { value: '568A', label: '568-A' },
  { value: '568B', label: '568-B' },
  { value: 'TERA', label: 'TERA' }
]

const toIntlLocale = language => language === 'jp-JP' ? 'ja-JP' : language

const getLanguageDisplayName = (code, language, fallback) => {
  try {
    if (typeof Intl !== 'undefined' && Intl.DisplayNames) {
      return new Intl.DisplayNames([toIntlLocale(language || 'en-GB')], { type: 'language' }).of(toIntlLocale(code)) || fallback || code
    }
  } catch (error) {
    // Older browsers and unsupported locales use the supplied label.
  }

  return fallback || code
}

export const getLanguageOptions = (languages, activeLanguage) => {
  const availableLanguages = (languages || []).filter(language => language && language.code)
  const options = availableLanguages.length
    ? availableLanguages
    : [{ code: 'en-GB', name: 'English (United Kingdom)' }]

  return options.map(language => ({
    value: language.code,
    label: getLanguageDisplayName(language.code, activeLanguage, language.name)
  }))
}
